import ToggleItem from "../Common/ToggleItem";
import CommonToggleContainer from "../Common/CommonToggleContainer";
import Utils from "../Shared/Utils";
import UIManager from "../Shared/UIManager";
import NetworkLogic from "../Shared/NetworkLogic";
import SDKManager from "../Shared/SDKManager";
import { Global } from "../Shared/Global";
import AudioManager from "../Shared/AudioManager";
import WebViewManager from "../Shared/WebViewManager";
import EnterSoundManager from "../Shared/EnterSoundManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class CustomerServiceUI extends cc.Component {
    @property(CommonToggleContainer)
    toggleContainer: CommonToggleContainer = null
    
    @property(cc.Widget)
    wgtNode: cc.Widget = null
    
    @property(cc.Node)
    nodeList: cc.Node = null

    @property(cc.Node)
    nodeProblems: cc.Node = null

    @property(cc.Node)
    nodeTemplateChatItem: cc.Node = null

    @property(cc.Node)
    nodeTemplateQuestionItem: cc.Node = null

    @property(cc.Layout)
    lytContentChat: cc.Layout = null

    @property(cc.Layout)
    lytContentQuestion: cc.Layout = null

    customerTypeName: string = ""

    private _urlOnlineChat: string = ""

    onLoad () {
        this.nodeList.active = false
        this.nodeProblems.active = false
        this.nodeTemplateChatItem.parent = null
        this.nodeTemplateQuestionItem.parent = null
        Utils.hideGameNode()
    }

    start () {
        UIManager.showLoadingUI()
        NetworkLogic.customServiceList(function (data) {
            UIManager.hideLoadingUI()
            this.createToggles(data)
        }.bind(this))
        EnterSoundManager.playSound("enter_kefu")
    }

    onDestroy () {
        this.nodeTemplateChatItem.destroy()  
        this.nodeTemplateQuestionItem.destroy()
    }

    onBtnClick (event, userData) {
        if (userData === "back") {
            AudioManager.playSound("close")
            Utils.showGameNode()
            this.node.destroy()
        }else if (userData === "chat") {
            let id = event.target["ChatID"]

            if (event.target["ChatType"] === "Online") {
                let wvManager = cc.find("Canvas") && cc.find("Canvas").getComponent(WebViewManager)
                if (wvManager) {
                    Utils.setOrientation("V")
                    wvManager.openOnlineKefu(this._urlOnlineChat)
                }
            }else if (event.target["ChatType"] === "QQ") {
                if (SDKManager.isInstall(SDKManager.UMSocialPlatformType.QQ)) {
                    cc.sys.openURL("mqq://im/chat?chat_type=wpa&uin={0}&version=1&src_type=web"["format"](id))
                }else {
                    UIManager.showToastUI("您的设备尚未安装QQ", Global.ToastType.Warnning)
                }
            }else if (event.target["ChatType"] === "WECHAT") {
                Utils.copyText(id)
                UIManager.showConfirmUI("微信账号复制成功，请求跳转微信", function () {
                    if (SDKManager.isInstall(SDKManager.UMSocialPlatformType.WechatSession)) {
                        cc.sys.openURL("weixin://")
                    }else {
                        UIManager.showToastUI("您的设备尚未安装微信", Global.ToastType.Warnning)
                    }
                }.bind(this))
            }else if (event.target["ChatType"] === "MT") {
                Utils.copyText(id)
                UIManager.showConfirmUI("MT客服账号复制成功，请求跳转MT客服", function () {
                    if (!cc.sys.openURL("mtmessenger://")) {
                        UIManager.showLoadingUI()
                        NetworkLogic.getConfigValue("mtDownUrl", function (data) {
                            UIManager.hideLoadingUI()
                            cc.sys.openURL(data && data.value0 || "https://mtios.com")
                        }.bind(this))
                    }
                }.bind(this))
            }
        }
    }

    onToggleSelected (toggle: ToggleItem) {
        this.nodeList.active = false
        this.nodeProblems.active = false

        let data = toggle.userData

        if (data["type"] === "Online") {
            if (data["list"][0]) {
                this._urlOnlineChat = data["list"][0].content
            }
            this.nodeList.active = true
            this.createChatItems(data["list"], data["type"])
        }else if (data["type"] === "QQ" || data["type"] === "WECHAT" || data["type"] === "MT") {
            this.nodeList.active = true
            this.createChatItems(data["list"], data["type"])
        }else if (data["type"] === "CJ") {
            this.nodeProblems.active = true
            this.createQuestionItems(data["list"])
        }
    }

    private createToggles (data) {
        let names = {
            Online: "在线客服",
            QQ: "QQ客服",
            WECHAT: "微信客服",
            MT: "MT客服",
            CJ: "常见问题",
        }

        data.forEach(item => {
            let toggle = this.toggleContainer.addDefaultToggle(names[item.type] || item.type, item)
            if (this.customerTypeName && names[item.type] === this.customerTypeName) {
                this.toggleContainer.selectToggle(toggle)
            }
        });
    }

    private createChatItems (items, type) {
        this.lytContentChat.node.destroyAllChildren()

        items.forEach(item => {
            let node = cc.instantiate(this.nodeTemplateChatItem)
            node.getChildByName("name").getComponent(cc.Label).string = item.customerName
            node.getChildByName("btn")["ChatID"] = item.content
            node.getChildByName("btn")["ChatType"] = type

            if (type === "Online") {
                node.getChildByName("id").getComponent(cc.Label).string = "在线客服"
            }else {
                node.getChildByName("id").getComponent(cc.Label).string = item.content
            }
            
            if (type === "QQ" || type === "Online") {
                cc.find("btn/name", node).getComponent(cc.Label).string = "联系客服"
            }else if (type === "WECHAT") {
                cc.find("btn/name", node).getComponent(cc.Label).string = "复制微信号"
            }else if (type === "MT") {
                cc.find("btn/name", node).getComponent(cc.Label).string = "复制MT号"
            }

            cc.loader.load(item.icon, function (err, texture) {
                if (!err && node && node.isValid) {
                    node.getChildByName("head").getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
                }
            }.bind(this))
            node.parent = this.lytContentChat.node
        });
    }
    
    private createQuestionItems (items) {
        this.lytContentQuestion.node.destroyAllChildren()

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            let node = cc.instantiate(this.nodeTemplateQuestionItem)
            node.getChildByName("title").getComponent(cc.Label).string = i + 1 + "、" + item.content
            node.getChildByName("text").getComponent(cc.Label).string = item.icon
            node.parent = this.lytContentQuestion.node
        }
    }
}
